import angular from 'angular';
import { keys } from 'lodash';

// A common controller shared between the market and admin style guides.
//
// Sets mock / dummy data that can be used to show off data-driven components
// in the styleguide.
//
// To use: use `resolve` to define a property called `mocks`, which should be a
// map from the name of a mock to a static object containing mock data. The
// controller will make each of these mocks available on itself.
//
// For example, if you resolve `mocks = { 'abc': 'xyz' }` and use
// `controllerAs: 'styleMocks'`, then you can access your mock via
// `styleMocks.abc`.
module.exports = angular.module('common.controllers.style-mocks', [])
.controller('commonStyleMocksCtrl', class {
  constructor(mocks) {
    // Make all the mocks available on the controller so they can be easily
    // accessed from templates
    keys(mocks).forEach((mockName) => {
      this[mockName] = mocks[mockName];
    });
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/controllers/style-mocks.js
 **/